export const TrainingItemGroupManagementConstants: Readonly<{
    trainingItemGroupManagementHeaderText: string;
    trainingItemGroupManagementConfirmationHeaderText:string;
    trainingItemGroupManagementConfirmationMessageText:string;
  }> = {
    trainingItemGroupManagementHeaderText : "Training Item Group Management",
    trainingItemGroupManagementConfirmationHeaderText : "Confirmation",
    trainingItemGroupManagementConfirmationMessageText : "Any unsaved changes will be lost. Do you want to continue?",
  };
